// @ts-nocheck
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { GoogleMap, InfoWindow, Marker } from '@react-google-maps/api';
import { Typography } from '@mui/material';
import { useGoogleMaps } from '../../hooks/GoogleMapsContext';
import home from '../../assets/images/home.png';
import greyPin from '../../assets/images/grey_pin.png';

const Map = () => {
    const [showInfoWindow, setShowInfoWindow] = useState(false);
    const [showIndex, setShowIndex] = useState(0);

    const [defaultCenter, setDefaultCenter] = useState({
        lat: 33.302947,
        lng: -111.803276,
    });
    const mapStyles = {
        height: 'calc(100vh - 200px)',
        width: '100%',
    };

    const { appointmentMaps, useHomeAddress } = useSelector((state: RootState) => state.appointmentMap);
    const { loaded } = useGoogleMaps();

    useEffect(() => {
        if (appointmentMaps.Appointments && appointmentMaps.Appointments.length > 0) {
            var first = appointmentMaps.Appointments[0];
            if (first.Location) {
                const lat = typeof first.Location.lat === 'number' ? first.Location.lat : Number(first.Location.lat);
                const lng = typeof first.Location.lng === 'number' ? first.Location.lng : Number(first.Location.lng);
                if (!isNaN(lat) && !isNaN(lng)) {
                    setDefaultCenter({ lat, lng });
                }
            }
        }
    }, [appointmentMaps]);

    const mouseOver = (show: boolean, index: number) => {
        setShowIndex(index);
        setShowInfoWindow(show);
    };

    // Helper function to validate and convert position
    const getValidPosition = (location: any) => {
        if (!location) return null;
        const lat = typeof location.lat === 'number' ? location.lat : Number(location.lat);
        const lng = typeof location.lng === 'number' ? location.lng : Number(location.lng);
        if (isNaN(lat) || isNaN(lng)) return null;
        return { lat, lng };
    };

    if (!loaded) {
        return <Typography>Loading map...</Typography>;
    }

    // Keep list and map numbering aligned: use the Appointments array index (1-based).
    // Appointments without a mappable Location still appear in the list but get no pin.
    const appointmentsWithIndex =
        appointmentMaps.Appointments?.map((apptMap, index) => ({
            apptMap,
            listIndex: index + 1,
            position: getValidPosition(apptMap.Location),
        })) || [];

    return (
        <GoogleMap mapContainerStyle={mapStyles} zoom={11} center={defaultCenter}>
            {appointmentsWithIndex.map(({ apptMap, listIndex, position }) => {
                if (!position) return null;

                return (
                    // @ts-ignore
                    <Marker
                        onMouseOver={() => {
                            mouseOver(true, listIndex);
                        }}
                        onMouseOut={() => {
                            mouseOver(false, listIndex);
                        }}
                        zIndex={listIndex}
                        opacity={0.8}
                        label={{ text: listIndex.toString(), color: 'white', fontWeight: 'bold' }}
                        key={apptMap.id || `appointment-${listIndex}`}
                        position={position}
                        icon={apptMap.Checked ? greyPin : ''}
                    >
                        {
                            // @ts-ignore
                            showInfoWindow && showIndex === listIndex ? (
                                <InfoWindow>
                                    <>
                                        <Typography style={{ fontWeight: 'bold' }}>{'(' + listIndex + ') ' + apptMap.MemberName}</Typography>
                                        <hr />
                                        <Typography>{apptMap.address}</Typography>
                                        <br />
                                        <Typography>{apptMap.reason}</Typography>
                                    </>
                                </InfoWindow>
                            ) : null
                        }
                    </Marker>
                );
            })}
            {useHomeAddress
                ? (() => {
                      const providerHomePosition = getValidPosition(appointmentMaps.ProviderHomeLocation);
                      if (!providerHomePosition) return null;

                      return (
                          <Marker
                              onMouseOver={() => {
                                  mouseOver(true, -1);
                              }}
                              onMouseOut={() => {
                                  mouseOver(false, -1);
                              }}
                              zIndex={-1}
                              opacity={0.8}
                              label={{ text: 'PH', color: 'white', fontWeight: 'bold' }}
                              key={'providerHome'}
                              position={providerHomePosition}
                              icon={home}
                          >
                              {
                                  // @ts-ignore
                                  showInfoWindow && showIndex === -1 ? (
                                      <InfoWindow>
                                          <>
                                              <Typography style={{ fontWeight: 'bold' }}>{'(PH) Provider Home'}</Typography>
                                          </>
                                      </InfoWindow>
                                  ) : null
                              }
                          </Marker>
                      );
                  })()
                : null}
        </GoogleMap>
    );
};

export default Map;
